import { registerActions } from "../actionRegistry";
/**
 * E-commerce Functions
 *
 * Functions for e-commerce transfer and product settings.
 */

import { api } from "../api";
import { toastSuccess, toastError } from "../ui/messages";
import { closeModalLast, refreshModal } from "../ui/modal";
import { getDomElement, queryAll } from "../utils/dom";
import { replaceAll } from "../utils/string";
import { transfershow } from "./toggles";

/**
 * Execute e-commerce transfer for selected artworks and products
 */
export async function ecommercetransfer(): Promise<void> {
  let transfer_ok1 = 0;
  let transfer_ok2 = 0;

  for (const el of queryAll<HTMLInputElement>(".ecommercetransfer-artwork")) {
    if (el.id && el.checked) transfer_ok1 = 1;
  }

  for (const el of queryAll<HTMLInputElement>(".ecommercetransfer-product")) {
    if (el.id && el.checked) transfer_ok2 = 1;
  }

  if (transfer_ok1 !== 1 || transfer_ok2 !== 1) {
    toastError("No products to transfer");
    return;
  }

  let synclist = "";

  for (const artEl of queryAll<HTMLInputElement>(".ecommercetransfer-artwork")) {
    const the_id = artEl.id;
    if (!the_id) continue;

    const raw_id = the_id.replace("sync-", "");
    if (!artEl.checked) continue;

    let passep = 0;
    if (getDomElement<HTMLInputElement>(`transfer_passepartout_${raw_id}`)?.value === "1") {
      passep = 1;
    }

    let interior = getDomElement<HTMLInputElement>(`transfer_interiors_${raw_id}`)?.value ?? "";
    interior = replaceAll(interior, ",", "!");

    let coll_name = getDomElement<HTMLInputElement>(`transfer_collection_${raw_id}`)?.value ?? "";
    coll_name = replaceAll(coll_name, ",", "");
    coll_name = replaceAll(coll_name, ":", "");
    coll_name = replaceAll(coll_name, "!", "");

    let products = "";
    for (const prodEl of queryAll<HTMLInputElement>(`.prodloop-${raw_id}`)) {
      const the_id2 = prodEl.id;
      if (!the_id2) continue;
      const raw_id2 = the_id2.replace(`transfer_products_${raw_id}-`, "");
      if (prodEl.checked) {
        if (products) products += "!";
        products += raw_id2;
      }
    }

    let stores = "";
    for (const integEl of queryAll<HTMLInputElement>(`.integloop-${raw_id}`)) {
      const the_id2 = integEl.id;
      if (!the_id2) continue;
      const raw_id2 = the_id2.replace(`transfer_integ_${raw_id}-`, "");
      if (integEl.checked) {
        if (stores) stores += "!";
        stores += raw_id2;
      }
    }

    if (synclist !== "") synclist += ",";
    synclist += `${raw_id}:${passep}:${interior}:${coll_name}:${products}:${stores}:`;
  }

  if (!synclist) return;

  try {
    await api.ecommerce.transfer({
      id: synclist,
      collName: getDomElement<HTMLInputElement>("transfer_collection")?.value,
    });
    closeModalLast();
    toastSuccess("Added to eCommerce transfer queue");
    transfershow();
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}

export async function deleteproducttemplate(id: string): Promise<void> {
  if (
    !confirm(
      "Are you sure you want to remove product template? This will not delete synced products"
    )
  )
    return;
  try {
    await api.ecommerce.deleteProduct({ id });
    toastSuccess("Product template removed");
    closeModalLast();
    setTimeout(() => {
      refreshModal();
    }, 500);
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}

export async function deleteplugin(id: string): Promise<void> {
  if (!confirm("Are you sure you want to remove plugin? This will not delete synced products"))
    return;
  try {
    await api.ecommerce.deletePlugin({ id });
    toastSuccess("Plugin removed");
    setTimeout(() => {
      refreshModal();
    }, 500);
  } catch (err: unknown) {
    toastError((err as Error).message);
  }
}

registerActions({
  ecommercetransfer,
});
